import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import login from './login';
import clients from './clients';

const rootReducer = combineReducers({
  login,
  clients,
  routing: routerReducer,
});

export default rootReducer;
